import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';  // Global CSS styles
import App from './App';  // Main App component

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);